import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enAuth from './locales/en/auth.json';
import enVaults from './locales/en/vaults.json';
import enPortfolio from './locales/en/portfolio.json';
import enDashboard from './locales/en/dashboard.json';
import enMarketplace from './locales/en/marketplace.json';
import enProfile from './locales/en/profile.json';
import enLanding from './locales/en/landing.json';
import enFaq from './locales/en/faq.json';
import enLegal from './locales/en/legal.json';
import enFooter from './locales/en/footer.json';
import enWallet from './locales/en/wallet.json';
import enInvestment from './locales/en/investment.json';
import enReferral from './locales/en/referral.json';
import enNft from './locales/en/nft.json';
import enPasswordReset from './locales/en/passwordReset.json';
import enTax from './locales/en/tax.json';
import enTokenomics from './locales/en/tokenomics.json';
import enDisclaimer from './locales/en/disclaimer.json';
import enErrors from './locales/en/errors.json';
import enAdminCommon from './locales/en/admin/common.json';
import enAdminNavigation from './locales/en/admin/navigation.json';
import enAdminDashboard from './locales/en/admin/dashboard.json';

import ruCommon from './locales/ru/common.json';
import ruNavigation from './locales/ru/navigation.json';
import ruAuth from './locales/ru/auth.json';
import ruVaults from './locales/ru/vaults.json';
import ruPortfolio from './locales/ru/portfolio.json';
import ruDashboard from './locales/ru/dashboard.json';
import ruMarketplace from './locales/ru/marketplace.json';
import ruProfile from './locales/ru/profile.json';
import ruLanding from './locales/ru/landing.json';
import ruFaq from './locales/ru/faq.json';
import ruLegal from './locales/ru/legal.json';
import ruFooter from './locales/ru/footer.json';
import ruWallet from './locales/ru/wallet.json';
import ruInvestment from './locales/ru/investment.json';
import ruReferral from './locales/ru/referral.json';
import ruNft from './locales/ru/nft.json';
import ruPasswordReset from './locales/ru/passwordReset.json';
import ruTax from './locales/ru/tax.json';
import ruTokenomics from './locales/ru/tokenomics.json';
import ruDisclaimer from './locales/ru/disclaimer.json';
import ruErrors from './locales/ru/errors.json';
import ruAdminCommon from './locales/ru/admin/common.json';
import ruAdminNavigation from './locales/ru/admin/navigation.json';
import ruAdminDashboard from './locales/ru/admin/dashboard.json';

const resources = {
  en: {
    common: enCommon,
    navigation: enNavigation,
    auth: enAuth,
    vaults: enVaults,
    portfolio: enPortfolio,
    dashboard: enDashboard,
    marketplace: enMarketplace,
    profile: enProfile,
    landing: enLanding,
    faq: enFaq,
    legal: enLegal,
    footer: enFooter,
    wallet: enWallet,
    investment: enInvestment,
    referral: enReferral,
    nft: enNft,
    passwordReset: enPasswordReset,
    tax: enTax,
    tokenomics: enTokenomics,
    disclaimer: enDisclaimer,
    errors: enErrors,
    adminCommon: enAdminCommon,
    adminNavigation: enAdminNavigation,
    adminDashboard: enAdminDashboard,
  },
  ru: {
    common: ruCommon,
    navigation: ruNavigation,
    auth: ruAuth,
    vaults: ruVaults,
    portfolio: ruPortfolio,
    dashboard: ruDashboard,
    marketplace: ruMarketplace,
    profile: ruProfile,
    landing: ruLanding,
    faq: ruFaq,
    legal: ruLegal,
    footer: ruFooter,
    wallet: ruWallet,
    investment: ruInvestment,
    referral: ruReferral,
    nft: ruNft,
    passwordReset: ruPasswordReset,
    tax: ruTax,
    tokenomics: ruTokenomics,
    disclaimer: ruDisclaimer,
    errors: ruErrors,
    adminCommon: ruAdminCommon,
    adminNavigation: ruAdminNavigation,
    adminDashboard: ruAdminDashboard,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'takara_language',
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
